import { AccessPermissionsEnum } from '@/router/constants';

function load(component) {
  return () => import(`@/views/${component}.vue`);
}

export default [
  {
    path: 'integrations',
    name: 'integrations',
    component: load('integrations/Integrations'),
    meta: {
      requiresAuth: true,
      roles: ['admin'],
      accessPermissions: [AccessPermissionsEnum.CAN_READ_INTEGRATIONS],
      icon: 'puzzle',
      menuItems: 'leftSideMenu.integrations',
    },
  },
  {
    path: 'integrations/select',
    name: 'integrations:select',
    component: load('integrations/SelectIntegration'),
    meta: {
      requiresAuth: true,
      roles: ['admin'],
      accessPermissions: [AccessPermissionsEnum.CAN_READ_INTEGRATIONS],
      icon: 'puzzle',
      menuItems: 'leftSideMenu.integrations',
    },
  },
  {
    path: 'integrations/pos/create',
    name: 'integrations:pos:create',
    component: load('integrations/EditPos'),
    meta: {
      requiresAuth: true,
      roles: ['admin'],
      accessPermissions: [AccessPermissionsEnum.CAN_READ_INTEGRATIONS],
      icon: 'puzzle',
      menuItems: 'leftSideMenu.integrations',
    },
  },
  {
    path: 'integrations/iiko/create',
    name: 'integrations:iiko:create',
    component: load('integrations/iiko/EditIiko'),
    meta: {
      requiresAuth: true,
      roles: ['admin'],
      accessPermissions: [AccessPermissionsEnum.CAN_READ_INTEGRATIONS],
      icon: 'puzzle',
      menuItems: 'leftSideMenu.integrations',
    },
  },
  {
    path: 'integrations/iiko/edit/:id',
    name: 'integrations:iiko:edit',
    component: load('integrations/iiko/EditIiko'),
    meta: {
      requiresAuth: true,
      roles: ['admin'],
      accessPermissions: [AccessPermissionsEnum.CAN_READ_INTEGRATIONS],
      icon: 'puzzle',
      menuItems: 'leftSideMenu.integrations',
    },
  },
  {
    path: 'integrations/rkeeper/create',
    name: 'integrations:rkeeper:create',
    component: load('integrations/EditRkeeper'),
    meta: {
      requiresAuth: true,
      roles: ['admin'],
      accessPermissions: [AccessPermissionsEnum.CAN_READ_INTEGRATIONS],
      icon: 'puzzle',
      menuItems: 'leftSideMenu.integrations',
    },
  },
  {
    path: 'integrations/messenger/create',
    name: 'integrations:messenger:create',
    component: load('integrations/EditMessenger'),
    meta: {
      requiresAuth: true,
      roles: ['admin'],
      accessPermissions: [AccessPermissionsEnum.CAN_READ_INTEGRATIONS],
      icon: 'puzzle',
      menuItems: 'leftSideMenu.integrations',
    },
  },
  {
    path: 'integrations/tips',
    name: 'integrations:tips',
    component: load('integrations/EditTips'),
    meta: {
      requiresAuth: true,
      roles: ['admin'],
      accessPermissions: [AccessPermissionsEnum.CAN_READ_INTEGRATIONS],
      icon: 'puzzle',
      menuItems: 'leftSideMenu.integrations',
    },
  },
  {
    path: 'integrations/iiko',
    name: 'integrations:iiko:list',
    component: load('integrations/iiko/IikoIntegrations'),
    meta: {
      requiresAuth: true,
      roles: ['admin'],
      accessPermissions: [AccessPermissionsEnum.CAN_READ_INTEGRATIONS],
      icon: 'iiko',
      menu: {
        title: 'IIKO',
        icon: 'iiko',
      },
    },
  },
];
